import { downloadFile } from "@/services/generic.methods";

const processedLeadExportKeys = new Set();

export function parseLeadExportData(data) {
  let exportData = data;
  if (typeof exportData === "string") {
    try {
      exportData = JSON.parse(exportData);
    } catch (e) {
      // keep original string
    }
  }
  return exportData;
}

function getLeadExportDedupeKey(exportData, notification) {
  if (typeof exportData === "string") {
    return exportData;
  }
  return (
    exportData?.download_url ||
    exportData?.file_url ||
    exportData?.file_name ||
    notification?.id ||
    notification?.notificationId
  );
}

/**
 * Handles a LeadExport notification download exactly once per unique export.
 * @returns {{ handled: boolean, duplicate?: boolean, needsFallback?: boolean, exportData?: unknown }}
 */
export function handleLeadExportNotification(notification) {
  if (notification?.type !== "LeadExport" && notification?.type !== "ReportExport") {
    return { handled: false };
  }

  const isReport = notification?.type === "ReportExport";
  const exportData = parseLeadExportData(notification?.data);
  const dedupeKey = getLeadExportDedupeKey(exportData, notification);

  if (dedupeKey && processedLeadExportKeys.has(dedupeKey)) {
    return { handled: true, duplicate: true, exportData };
  }

  if (dedupeKey) {
    processedLeadExportKeys.add(dedupeKey);
  }

  const downloadUrl = exportData?.download_url || exportData?.file_url;
  if (downloadUrl) {
    downloadFile(null, exportData?.file_name || "download", downloadUrl);
    return { handled: true, exportData };
  }

  return {
    handled: true,
    needsFallback: true,
    exportData: notification?.data,
    isReport,
  };
}
